export default {
  cta: "Start producing",
  title: "Overview of operations",
  leftTitle: "Start producing!",
  leftSubtitle: "Planning for the second batch"
};
